import React from 'react';
import PropTypes from 'prop-types';

class Popup extends React.Component {
  getDimensions = () => (this.trigger ? this.trigger.getBoundingClientRect() : null);
  getRef = (node) => (this.trigger = node);
  onMouseAction = (show) => () => this.setState({ show });

  constructor(props) {
    super(props);
    this.state = { show: false };
    this.trigger = null;
  }

  render() {
    const { children, renderPopup, visible = true, ...rest } = this.props,
      components = [
        children instanceof Function
          ? children(
              { ref: this.getRef, ...rest },
              this.onMouseAction(true),
              this.onMouseAction(false)
            )
          : children
      ];
    if (visible && this.state.show)
      components.push(renderPopup(this.getDimensions(), this.trigger));
    return components;
  }
}

Popup.propTypes = {
  renderPopup: PropTypes.func,
  children: PropTypes.func,
  visible: PropTypes.bool
};

export default Popup;
